export * from './lib/order-details/order-details.component'